/* global axios */
import ApiClient from './ApiClient';

class IngestionSourcesAPI extends ApiClient {
  constructor() {
    super('ingestion_sources', { accountScoped: true });
  }

  rotateToken(id) {
    return axios.post(`${this.url}/${id}/rotate_token`);
  }
}

export default new IngestionSourcesAPI();
